import _ from 'lodash'

export default function getPaginationButtons(collection) {
  const buttons = collection.map(item => item.name[0].toLowerCase())

  return _.uniq(buttons).sort()
}
